@if (kycPLverification) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.deposit.kyc.verification.msg1' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.deposit.kyc.verification.msg2' | translate }}</p>
            <button (click)="openKycRedirectUrl()" class="btn btn-primary btn-sm mt-1 float-right">
                {{ 'PARTY.CASHIER.web.deposit.kyc.verify.message' | translate }}
            </button>
        </div>
    </show-message>
}

@if (bwinPLkycverification?.templateName == 'redirect_deposit_amount_exceeded') {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong> {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg1' | translate }} </strong>
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.kyc.301.msg2'
                        | translate
                            : {
                                  accountbalanceInfo: userBalance | vnCurrency: currencyPLN,
                              }
                }}
            </p>
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.kyc.301.msg3'
                        | translate
                            : {
                                  amount: depositLimit | vnCurrency: currencyPLN,
                              }
                }}
            </p>
            <div class="space-between mt-2">
                <button type="submit" class="btn btn-primary btn-sm" (click)="depositBack()">
                    {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg4' | translate }}
                </button>
                <button type="button" class="btn btn-primary ml-2 btn-sm" (click)="submitPLDeposit()">
                    {{ 'PARTY.CASHIER.web.deposit.button' | translate }}
                </button>
            </div>
        </div>
    </show-message>
}

@if (kycPLlimitverification?.templateName == 'redirect_deposit_amount_exceeded') {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong> {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg1' | translate }} </strong>
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.kyc.301.msg2'
                        | translate
                            : {
                                  accountbalanceInfo: userBalance | vnCurrency: currencyPLN,
                              }
                }}
            </p>
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.kyc.302.msg1'
                        | translate
                            : {
                                  amount: depositLimit | vnCurrency: currencyPLN,
                              }
                }}
            </p>
            <button type="button" class="btn btn-primary mt-2 btn-sm" (click)="submitPLDeposit()" id="submitPlDeposit">
                {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg5' | translate }}
            </button>
        </div>
    </show-message>
}
